'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a title for the top menu
 *
 * @class
 */

class TopNavTitle extends Core {

	_defaults() {
		return {
			target: '.js-menu-title',
			fields: {
				'name': 'Unnamed',
                'readonly': false
			}
		};
	}

	constructor(options) {
		super(options);

        if(options.fields['readonly']){
            this.template = `
                <div class='editor__topnav__title'>
                    <span class='js-menu-title'>
                        <%- name %>
                    </span>
                </div>
            `;
        }else{
            this.template = `
                <a class='editor__topnav__title non-selectable js-editor__topnav__title'>
                    <span class='editor__topnav__title__span js-menu-title'>
                        <%- name %>
                    </span>
                </a>
            `;
        }
		

		super.render(true);

        /**
         * Click event
         *
         * @fires TopNavTitle#_clicked
         */
        $('.js-editor__topnav__title', this.$el).on('click', this._clicked);
	}

    /**
     * @event TopNavTitle#Cioui:TopNavTitle:clicked
     * @property {String}Cioui:TopNavTitle:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TopNavTitle:clicked', e);
    }

    /**
     * Set a title in the menu
     * @param {String} title - A string with the desired title
     * @returns none
     */

    setTitle(title){
        $('.js-menu-title', this.$el).text(title);
    }

    /**
     * When the title is active mouse can interact with it and on mouse hover title style changes
     */
    setActive() {
        this.$el.removeClass('editor__topnav__title--inactive');
    }

    setInActive() {
        this.$el.addClass('editor__topnav__title--inactive');
    }
}
module.exports = TopNavTitle;